export var Tidsperiodetype;
(function (Tidsperiodetype) {
    Tidsperiodetype[Tidsperiodetype["Fravaer"] = 1] = "Fravaer";
})(Tidsperiodetype || (Tidsperiodetype = {}));
export var Tjenestetype;
(function (Tjenestetype) {
    Tjenestetype[Tjenestetype["ekontakt"] = 1] = "ekontakt";
    Tjenestetype[Tjenestetype["ekonsultasjon"] = 2] = "ekonsultasjon";
    Tjenestetype[Tjenestetype["timebestilling"] = 3] = "timebestilling";
    Tjenestetype[Tjenestetype["reseptfornyelse"] = 4] = "reseptfornyelse";
})(Tjenestetype || (Tjenestetype = {}));
